import { useState } from "react"
import { DinamicForm } from "../../../../.."
import { InputModel, onChange } from "../../../../../../../utils/types"
import dayjs, { Dayjs } from "dayjs"
import { monthYear } from "../../../../../../../utils/constants/date_month"
import { ObjectGeneric } from "../../../../../../../utils/types/generals"
import { SelectsProps } from "./types"
import { useFormContext } from "react-hook-form"
import { Box, Typography } from "@mui/material"
import { useContextState } from "../../../../../../../hooks/theme"
import { checkDate } from "../methods"

const today = dayjs()

const mins = new Array(60).fill(1).map((_, index) => ({
    label: `${index}`,
    value: `${index}`
}))

const hours = new Array(12).fill(1).map((_, index) => ({
    label: `${index + 1}`,
    value: `${index + 1}`
}))

const years = new Array(5).fill(1).map((_, index) => ({
    label: `${today.year() + index}`,
    value: today.year() + index
}))

const months = monthYear.map(item => ({ ...item, value: item.value + 1 }))

const days = ({ date }: { date: Dayjs }) => {
    return new Array(date.daysInMonth()).fill(1).map((_, index) => ({
        label: `${index + 1}`,
        value: index + 1
    }))
}
// const formatDate = ({ min, max, value, }: { min?: Dayjs, max?: Dayjs; value?: Dayjs }) => {
//     const localeDate = dayjs(value)
//     const localeMin = dayjs(min)
//     const localeMax = dayjs(max)
//     const minDay = localeMin.date()
//     const maxDay = localeMax.date()
//     const isSameMontMin = localeDate.isSame(localeMin, 'month')
//     const isSameMonthMax = localeDate.isSame(localeMax, 'month')
//     const isMinusMonth = localeMin.isBefore(localeDate, 'month')
//     const isIUpperMonth = localeMax.isAfter(localeDate, 'month')
//     const dayList = new Array(localeDate.daysInMonth()).fill(1).map((_, index) => ({
//         label: `${index + 1}`,
//         value: index + 1
//     }))

//     const hourList = new Array(12).fill(1).map((_, index) => ({
//         label: `${index + 1}`,
//         value: index + 1
//     }))
//     return {
//         days: dayList.filter(item => (!min || !!isMinusMonth || (!!min && isSameMontMin && item.value >= minDay))).filter(item => (!max || !!isIUpperMonth || (!!max && isSameMonthMax && item.value <= maxDay))),
//         hours: hourList
//     }
// }

const Selects = ({ min, max, name, is, isDateForm }: SelectsProps) => {
    const { colors } = useContextState()
    const { getValues, setValue } = useFormContext()
    const [errors, setErrors] = useState('')
    const value = getValues(name)
    const today = dayjs(value)
    const [input, setInput] = useState<Record<string, InputModel>>({
        ...(isDateForm && {
            day: {
                label: 'Día',
                name: 'day',
                type: 'select-search',
                items: days({ date: today }),
                validate: {
                    required: true,
                },
                value: null,
                size: {
                    xl: 4,
                    lg: 4,
                    md: 4,
                    sm: 4,
                    xs: 4,
                },
            }
        }),
        ...(isDateForm && {
            month: {
                label: 'Mes',
                name: 'month',
                type: 'select-search',
                items: months,
                validate: {
                    required: true,
                },
                value: null,
                size: {
                    xl: 4,
                    lg: 4,
                    md: 4,
                    sm: 4,
                    xs: 4,
                },
            }
        }),
        ...(isDateForm && {
            year: {
                label: 'Año',
                name: 'year',
                type: 'select-search',
                items: years,
                validate: {
                    required: true,
                },
                value: null,
                size: {
                    xl: 4,
                    lg: 4,
                    md: 4,
                    sm: 4,
                    xs: 4,
                },
            }
        }),
        ...(!isDateForm && {
            hour: {
                label: 'Hora',
                name: 'hour',
                type: 'select-search',
                items: hours,
                validate: {
                    required: true,
                },
                value: null,
                size: {
                    xl: 4,
                    lg: 4,
                    md: 4,
                    sm: 4,
                    xs: 4,
                },
            }
        }),
        ...(!isDateForm && {
            min: {
                label: 'Minutos',
                name: 'min',
                type: 'select-search',
                items: mins,
                validate: {
                    required: true,
                },
                value: null,
                size: {
                    xl: 4,
                    lg: 4,
                    md: 4,
                    sm: 4,
                    xs: 4,
                },
            }
        }),
        ...(!isDateForm && {
            type: {
                label: 'Rango horario',
                name: 'type',
                type: 'select-search',
                items: [
                    {
                        label: 'AM',
                        value: 'AM',
                    },
                    {
                        label: 'PM',
                        value: 'PM',
                    },
                ],
                validate: {
                    required: true,
                },
                value: null,
                size: {
                    xl: 4,
                    lg: 4,
                    md: 4,
                    sm: 4,
                    xs: 4,
                },
            }
        }),
    })

    const [data, setData] = useState<ObjectGeneric>({
        day: today.date(),
        month: (today.month() + 1),
        year: today.year(),
        hour: today.format('h'),
        min: today.minute().toString(),
        type: today.format('A')
    })

    const onChange: onChange = (e) => {
        const { name: nameChange, value: valueChange } = e.target
        const value = valueChange?.value
        if (!!value) {
            const body = { ...data, [nameChange]: value }

            if (['month', 'year'].includes(nameChange)) {
                const month = (nameChange == 'month' ? value : body?.month) - 1
                const year = nameChange == 'year' ? value : body?.year
                const formatDate = dayjs().month(month ?? today.month()).year(year ?? today.year()).daysInMonth()
                const days = new Array(formatDate).fill(formatDate).map((_, index) => ({
                    label: `${index + 1}`,
                    value: index + 1
                }))
                if (body?.day > formatDate) {
                    body.day = null
                }
                setInput(prev => ({ ...prev, day: { ...prev.day, items: days } }))
            }
            const hour = Number(body.hour)
            const isTwelve = hour == 12
            const dateFormated = dayjs()
                .date(Number(body.day))
                .month(Number(body.month - 1))
                .year(Number(body.year))
                .hour(body?.type == 'AM' ? (isTwelve ? 0 : hour) : (isTwelve ? 12 : hour + 12))
                .minute(Number(body.min))
                .second(59)
            const message = checkDate({ min, max, value: dateFormated, isStart: !!is?.start })
            setValue(name, dateFormated)
            setValue('bad-date', !!message)
            setErrors(message)

            setData(body)
        }
    }

    return (
        <Box sx={{ width: '100%' }}>
            {!!errors && <Typography sx={{ color: colors.color28, fontSize: '10px', margin: '0px 0px 20px' }}>{errors}</Typography>}

            <DinamicForm
                input={Object.values(input)}
                onChange={onChange}
                values={data}
            />
        </Box>
    )
}

export { Selects }